/**
 * Regular expressions for domains.
 *
 * @see http://regexr.com/
 */
const DOMAINS = {
  // [quotes.healthcare.com, quotes.stg.healthcare.com, quotes.qa.healthcare.com, quotes.local.healthcare.com]
  // [quotes.healthcare.org, quotes.stg.healthcare.org, quotes.qa.healthcare.org, quotes.local.healthcare.org]
  quotes: /quotes\.(qa\.|stg\.|local\.)?healthcare\.(com|org)/i,

  // [mobile.healthcare.com, mobile.stg.healthcare.com, mobile.qa.healthcare.com, mobile.local.healthcare.com]
  quotesMobile: /mobile\.(qa\.|stg\.|local\.)?healthcare\.com/i,

  // [medicare.healthcare.com, medicare.stg.healthcare.com, medicare.qa.healthcare.com, medicare.local.healthcare.com]
  medicare: /medicare(\.qa|\.stg|\.local)?\.healthcare\.com/i,

  // [m.medicare.healthcare.com, m.medicare.stg.healthcare.com, m.medicare.qa.healthcare.com, m.medicare.local.healthcare.com]
  medicareMobile: /m\.medicare(\.qa|\.stg|\.local)?\.healthcare\.com/i,

  // [medicareguide.com, stg.medicareguide.com, qa.medicareguide.com, local.medicareguide.com]
  medicareguide: /(qa\.|stg\.|local\.)?medicareguide\.com/i,
};

export default DOMAINS;
